import { useContext, useEffect, useRef, useState } from 'react';
import { SidebarContext } from '../../context/SidebarContext';
import { SidebarGlobal } from './SidebarGlobal/SidebarGlobal';
import { userActive } from '../../assets/js/functions';
import './Sidebar.scss';

const Sidebar = () => {
	const { isSidebarOpen, closeSidebar } = useContext(SidebarContext);
	const navbarRef = useRef(null);
	const [user, setUser] = useState({});

	useEffect(() => {
		getUser();
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (navbarRef.current && !navbarRef.current.contains(event.target) && event.target.className !== 'sidebar-oepn-btn') {
			closeSidebar();
		}
	};

	const getUser = async () => {
		const data = await userActive();
		setUser(data);
	};

	return (
		<nav className={`sidebar ${isSidebarOpen ? 'sidebar-show' : ''}`} ref={navbarRef}>
			{/* Espacio superior ya lo da el padding-top en Sidebar.scss */}
			<SidebarGlobal />
		</nav>
	);
};

export default Sidebar;
